import React, { useEffect, useMemo } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  useLocation,
  useHistory
} from "react-router-dom";
import jwt from "jsonwebtoken";
import axios from "axios";
import { signOut } from '../context/UserContext';

// components
import Layout from "./Layout";
import Documentation from "./Documentation/Documentation";

// pages
import Error from "../pages/error";
import Login from "../pages/login";

// context
import { useUserState, useUserDispatch } from "../context/UserContext";
// import Pusher from 'pusher-js';
import Sockets from '../Sockets';

// window.Echo = new Echo({
//   broadcaster: 'pusher',
//   key: 'EQTqQKIOMW', // hard code
//   wsHost: process.env.REACT_APP_WEBSOCKET_HOST, 
//   enabledTransports: ['ws'],
//   wsPort:Number(process.env.REACT_APP_WEBSOCKET_PORT),
//   forceTLS: false,
//   disableStats: false
// });

const sockets = Sockets.shared();

const api = (userDispatch, history) => {
  // Set Base URL
  const apiHost = process.env.REACT_APP_API_HOST || 'https://dash-api-staging.sympler.co/';
  axios.defaults.baseURL = `${apiHost}api/v1`;

  // Check localstorage for auth token and orgId
  axios.interceptors.request.use(
    (config) => {
      const localStorageData = localStorage.getItem('SYMPLER');

      if (localStorageData) {
        const { token, user } = JSON.parse(localStorageData);

        if (token) {
          config.headers.common["Authorization"] = `Bearer ${token}`;
          config.headers.common["Organization-Id"] = 1;
        } else {
          config.headers.common["Authorization"] = null;
          config.headers.common["Organization-Id"] = null;
        }
      }

      return config;
    },
    (error) => {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use((response) => {
    return response;
}, function (error) {
    // Do something with response error
    if (error?.response?.status === 401) {
        console.log('unauthorized, logging out ...');

        signOut(userDispatch, history);
    }
    return Promise.reject(error.response);
});

  // Handle Errors
  // axios.interceptors.response.use(
  //   function(response) {
  //     // Do something with response data
  //     return response;
  //   },
  //   function(error) {
  //     // Do something with response error
  //     console.log(`failed to make network request with error: `, error);

  //     if (
  //       error &&
  //       error.response &&
  //       error.response.data &&
  //       error.response.data.message
  //     ) {
  //       return Promise.reject({
  //         status: error.response.data.status,
  //         errorMessage: error.response.data.message
  //       });
  //     }

  //     return Promise.reject({
  //       status: "failed",
  //       errorMessage: "An unknown error occurred. Please contact support"
  //     });
  //   }
  // );
};




const Routes = () => {
  const history = useHistory();
  var { isAuthenticated } = useUserState();
  var userDispatch = useUserDispatch();

  useMemo(() => {
    api(userDispatch, history);
  }, []);

  function PrivateRoute({ component, ...rest }) {
    const location = useLocation();
    const token = localStorage.getItem("token");
    const date = new Date().getTime() / 1000;
    const data = jwt.decode(token);
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            React.createElement(component, props)
          ) : (
            <Redirect to={"/login"} />
          )
        }
      />
    );
  }
  
  function PublicRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            <Redirect
              to={{
                pathname: "/"
              }}
            />
          ) : (
            React.createElement(component, props)
          )
        }
      />
    );
  }

  return (
    <Switch>
      <Route exact path="/" render={() => <Redirect to="/app/dashboard" />} />
      <Route
        exact
        path="/"
        render={() => <Redirect to="/app/dashboard" />}
      />
      {/* <Route path="/documentation" component={Documentation} /> */}
      <PrivateRoute path="/app" component={Layout} />
      <PublicRoute path="/login" component={Login} />
      <Route component={Error} />
    </Switch>
  );
}

export default function App() {
  return (
    <Router>
      <Routes />
    </Router>
  );

  // #######################################################################

}
